import script from "./CompareSimulationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareSimulationsPage.vue?vue&type=script&setup=true&lang=js"

import "./CompareSimulationsPage.vue?vue&type=style&index=0&id=145f9ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145f9ea8"]])

export default __exports__